export default "__VITE_ASSET__CZEYTFXp__"